import React, { useEffect, useState } from "react"
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    MenuItem,
    TextField,
    Typography,
} from "@mui/material"
import { CreateExperimentInput } from "../../../../services/ai-experiment.service"

type Props = {
    open: boolean
    onClose: () => void
    onSubmit: (input: CreateExperimentInput) => void
}

const PROVIDERS = [
    { value: "claude", label: "Claude (Anthropic)" },
    { value: "openai", label: "GPT (OpenAI)" },
    { value: "gemini", label: "Gemini (Google)" },
]

export const AIExperimentFormDialog: React.FC<Props> = ({ open, onClose, onSubmit }) => {
    const [name, setName] = useState("")
    const [providerA, setProviderA] = useState("claude")
    const [providerB, setProviderB] = useState("openai")
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        if (open) {
            setName("")
            setProviderA("claude")
            setProviderB("openai")
            setError(null)
        }
    }, [open])

    const handleSubmit = () => {
        if (!name.trim()) {
            setError("Nome é obrigatório")
            return
        }
        if (providerA === providerB) {
            setError("Os dois braços devem usar providers diferentes")
            return
        }
        onSubmit({ name: name.trim(), providerA, providerB })
    }

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Novo experimento A/B</DialogTitle>
            <DialogContent>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
                    <TextField
                        label="Nome do experimento"
                        placeholder="ex: beta-llm-comparison"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        error={!!error}
                        helperText={error || "Nome único para identificar o teste"}
                        fullWidth
                    />

                    <Box sx={{ display: "flex", gap: 2 }}>
                        <TextField
                            select
                            label="Braço A"
                            value={providerA}
                            onChange={(e) => setProviderA(e.target.value)}
                            fullWidth
                        >
                            {PROVIDERS.map((p) => (
                                <MenuItem key={p.value} value={p.value}>{p.label}</MenuItem>
                            ))}
                        </TextField>
                        <TextField
                            select
                            label="Braço B"
                            value={providerB}
                            onChange={(e) => setProviderB(e.target.value)}
                            fullWidth
                        >
                            {PROVIDERS.map((p) => (
                                <MenuItem key={p.value} value={p.value}>{p.label}</MenuItem>
                            ))}
                        </TextField>
                    </Box>

                    <Typography variant="caption" color="text.secondary">
                        No round 1, o grupo A usa o braço A e o grupo B usa o braço B. A cada crossover
                        os grupos trocam de braço. Participantes do experimento não usam fallback.
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancelar</Button>
                <Button variant="contained" onClick={handleSubmit}>Criar</Button>
            </DialogActions>
        </Dialog>
    )
}
